import React from 'react';
import ScoreboardComponent from '../components/ScoreboardComponent';
import Test from '../components/Test';
import { selectAuth } from '../slices/authSlice';
import { useSelector } from 'react-redux';


function ScoreboardPage() {

  const { isAuthenticated, userInformation } = useSelector(selectAuth);

  return (
    <div className="scoreboard">
      <h2>Scoreboard</h2>
        <ScoreboardComponent/>
         
        {/* <Test/> */}
    </div>
  );
}

export default ScoreboardPage;